import MangaCard from './MangaCard'
import { MangaCardSkeleton } from '../ui/Skeleton'
import { useMeta } from '../../api/useManga'

export default function MangaGrid({ items, loading, count = 12 }) {
  const { data: meta } = useMeta()
  const grid = 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4'

  if (loading) {
    return (
      <div className={grid}>
        {Array.from({ length: count }).map((_, i) => <MangaCardSkeleton key={i} />)}
      </div>
    )
  }

  if (!items?.length) {
    return (
      <div className="py-16 text-center">
        <p className="text-lg text-muted">Ничего не найдено</p>
      </div>
    )
  }

  return (
    <div className={grid}>
      {items.map((manga) => <MangaCard key={manga.id || manga.slug} manga={manga} meta={meta} />)}
    </div>
  )
}
